export class StudiesFilter {
  public pageSize?: number; // how many thing to return at a time
  public pageIndex?: number;
  public sortCriteria: SortCriteria; // if we need to support multiple maybe we make this a collection
  public filterCriteria: FilterCriteria[]; // I think we just use this to build out and conditions for each FilterCriteria item
  public isSearchStudy: boolean;
}

export class SortCriteria {
  public entity: string; // maybe this from an enum of possible entities to sort on?
  public isAscending: boolean; // true for ascending, false for descending
}

export class FilterCriteria {
  public entity: string; // maybe this from an enum of possible entities to sort on?
  public opcode: string; // maybe this is an enum of possible operators that match the UI>
  public value: string; // the value typed by the user
}
